import { render, staticRenderFns } from "./ProjectsSingleMore.vue?vue&type=template&id=a7ab5c4c&"
import script from "./ProjectsSingleMore.vue?vue&type=script&lang=js&"
export * from "./ProjectsSingleMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports